<div class="validate">
  <div
    class="modal-header"
    fxLayout="row"
    fxLayoutAlign="space-between center"
    fxLayoutAlign.lt-md="start center"
  >
    <h2>
      {{ "flows.modal.validation.title" | translate: { flow: model.flow_id } }}
    </h2>
  </div>
  <div class="modal-content mob-fixed-button">
    <div class="text-content" fxLayout="column" fxLayoutAlign="start center">
      <div class="icon mb-4" fxLayout="row" fxLayoutAlign="center center">
        <mat-icon svgIcon="icon_flows" class="ic-30 ic-svg-6"></mat-icon>
      </div>
      <div class="fs-18 pb-3 font-color">
        {{ "flows.modal.validation.subtitle" | translate }}
      </div>
      <div class="validate flow-validation-spinner">
      <div class="loading" *ngIf="loading">
        <div class="loading-icon"></div>
      </div>
      </div>
      <div class="fs-14 fc-6 pt-3">
        {{ "flows.modal.validation.description" | translate }}
      </div>
    </div>
  </div>
</div>
